import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 14c3-1 5-4 8-4 2 0 3.5 1 5 2l3-1-1.5 3c.5 1 .5 2.5-.5 3.5-2 2-6 1.5-9-1" }, null, -1),
    _createElementVNode("circle", {
      cx: "16.5",
      cy: "10.5",
      r: ".7",
      fill: "currentColor",
      stroke: "none"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-birds"}) } }